import type { SentryModule } from '../types';

export const MODULE_OWNERSHIP: Record<SentryModule, string> = {
  auth: 'team-auth',
  landing: 'team-pg-platform',
  landing_cdb: 'team-pg-platform',
  summary: 'team-pg-platform',
  onboarding: 'team-pg-platform',
  payment_links: 'team-payment-links',
  payment_forms: 'team-payment-forms',
  payment_buttons: 'team-payment-links',
  payments: 'team-payments',
  orders: 'team-orders',
  refunds: 'team-refunds',
  disputes: 'team-disputes',
  settlements: 'team-settlements',
  payouts: 'team-payouts',
  developers: 'team-developers',
  reports: 'team-reports',
  settings: 'team-settings',
  offers: 'team-pg-growth-offers',
  one_click_checkout: 'team-payment-links',
  easy_split: 'team-easy-split',
  softpos: 'team-softpos',
  customers: 'team-customers',
  customisation: 'team-settings',
  subscriptions: 'team-pg-growth',
  risk_shield: 'team-risk-shield',
  vba: 'team-vba',
  pg_team: 'team-pg',
};
